import { TFunction } from 'i18next';

export interface Country {
  name: string;
  code: string;
  className: string;
}

export const getCountryList = (t: TFunction): Country[] => [
  { name: t('country_ar'), code: 'AR', className: 'fi fi-ar' },
  { name: t('country_au'), code: 'AU', className: 'fi fi-au' },
  { name: t('country_br'), code: 'BR', className: 'fi fi-br' },
  { name: t('country_ca'), code: 'CA', className: 'fi fi-ca' },
  { name: t('country_co'), code: 'CO', className: 'fi fi-co' },
  { name: t('country_cl'), code: 'CL', className: 'fi fi-cl' },
  { name: t('country_cn'), code: 'CN', className: 'fi fi-cn' },
  { name: t('country_fr'), code: 'FR', className: 'fi fi-fr' },
  { name: t('country_in'), code: 'IN', className: 'fi fi-in' },
  { name: t('country_jp'), code: 'JP', className: 'fi fi-jp' },
  { name: t('country_mx'), code: 'MX', className: 'fi fi-mx' },
  { name: t('country_pt'), code: 'PT', className: 'fi fi-pt' },
  { name: t('country_es'), code: 'ES', className: 'fi fi-es' },
  { name: t('country_us'), code: 'US', className: 'fi fi-us' }
];
